// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import DocumentModeCanvasElementDebugger from './DocumentModeCanvasElementDebugger';
import DocumentModeCanvasReadingLineDebugger from './DocumentModeCanvasReadingLineDebugger';

// Styles
import './DocumentModeCanvasColumnDebugger.scss';

const getColumnBorderStyle = (gridSize, columnData) => {
    const bounds = columnData.getIn(['cluster', 'bounds']).toJS();

    return {
        top: bounds.top * gridSize,
        left: bounds.left * gridSize,
        width: (bounds.right - bounds.left) * gridSize,
        height: (bounds.bottom - bounds.top) * gridSize,
    };
};

const DocumentModeCanvasColumnDebugger = ({ gridSize, clusterIndex, columnIndex, columnData, elementOrder }) => {
    const columnReadingLines = columnData.get('readingData');
    const elementsData = columnData.get('children');

    return (
        <div className="DocumentModeCanvasColumnDebugger">
            <div className="column-border" style={getColumnBorderStyle(gridSize, columnData)} />
            {elementsData.map((clusterData, index) => (
                <DocumentModeCanvasElementDebugger
                    key={index}
                    gridSize={gridSize}
                    clusterIndex={clusterIndex}
                    columnIndex={index + 1}
                    elementClusterData={clusterData}
                    elementOrder={elementOrder}
                />
            ))}
            {columnReadingLines.map((readingLine, index) => (
                <DocumentModeCanvasReadingLineDebugger
                    className="element"
                    key={index}
                    gridSize={gridSize}
                    order={index + 1}
                    {...readingLine.toJS()}
                />
            ))}
        </div>
    );
};

DocumentModeCanvasColumnDebugger.propTypes = {
    gridSize: PropTypes.number.isRequired,
    clusterIndex: PropTypes.number.isRequired,
    columnIndex: PropTypes.number.isRequired,
    columnData: PropTypes.object.isRequired,
    elementOrder: PropTypes.object.isRequired,
};

export default DocumentModeCanvasColumnDebugger;
